import { Box } from '@mui/material'
import { HelpCenterCardsContainerContentTypeKey, HelpCenterCardsContainerProps } from './_props'
import { buildHelpCenterCards } from './useHelpCenterCards'
import { sxs } from './_sxs'
import { HelpCenterCard } from './HelpCenterCard'

export const HelpCenterCardsContainer = ({
    contentType = {
        exchangeViews: true,
        helpCenterAndTutorials: true,
        newsFeed: true,
        supportContact: true,
    },
    onClick,
}: HelpCenterCardsContainerProps) => {
    const contentTypes = Object.keys(contentType) as HelpCenterCardsContainerContentTypeKey[]
    const cards = buildHelpCenterCards(contentTypes, onClick)

    return (
        <Box sx={sxs.cardsContainer}>
            {cards.map((card) => (
                <HelpCenterCard
                    key={card.id}
                    id={card.id}
                    type={card.type}
                    icon={card.icon}
                    title={card.title}
                    description={card.description}
                    buttonName={card.buttonName}
                    url={card.url}
                    colorVariant={card.colorVariant}
                    buttonContent={card.buttonContent}
                    handleClick={card.url ? () => onClick?.(card.type, 'link') : undefined}
                />
            ))}
        </Box>
    )
}
